var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCanvasTent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 33,
  height: 33,
  fill: "none",
  viewBox: "0 0 33 33"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#222830",
  strokeLinejoin: "round",
  strokeWidth: 2.063,
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M31.281 18.563 16.431 1.375 1.72 18.563l1.1 13.062h6.737l7.013-17.6 5.912 17.6h7.15z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "m22.48 31.625 5.226-5.087-11.138-12.513"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h33v33H0z"
})))));
export default SvgCanvasTent;